import { Link, useParams } from "react-router-dom";
import { getClient } from "api/graphQL_clients";
import { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import { ClientContext } from "ClientProvider";
import CustomerRegistration from "./CustomerRegistration";
import AddTreasury from "./AddTreasury";
import AllPaymentsClient from "./AllPaymentsClient";
import AllPayoutsClient from "./AllPayoutsClient";
import ArrangeClientModal from "./ArrangeClientModal";
import CheckoutProductClientModal from "./CheckoutProductClientModal";
import CreateClientGatewaysModal from "./CreateClientGatewaysModal";
import { getAllOrganizationsSecond, getOrganization } from "api/graphQL_organizations";
import { storeAuditLogsGeneral } from "api/users";
import { clearAllCookie, setId, setUserId, getUserId } from "utils/auth";
import { getProfileSecond } from "api/graphQL_users";
export type AllGatewayObj = { name: string; id: string; };

const TAB_CONFIG = [
  { key: "gateway-setting", label: "Gateway Settings", icon: "gateway",  permission: "client_gateway_settings",permissionSource: "client"},
  { key: "checkout-setting", label: "Checkout Settings", icon: "checkout", permission: "client_checkout_setting",permissionSource: "client"},
  { key: "gateway-routing", label: "Gateway Routing", icon: "routing",  permission: "client_gateway_routing",permissionSource: "client"},
  { key: "treasury", label: "Manage Treasury", icon: "treasury", permission: "view_client_treasury",permissionSource: "client"},
  { key: "customer-registration", label: "Customer Registration",  icon: "users", permission: "customer_registration",permissionSource: "client"},
//   { key: "all-transactions", label: "All Transactions",  icon: "transactions", permission: ["view_payment_list","view_payout_list","view_batch_payout","view_crypto_payout_list","view_single_crypto_payout_list","view_fiat_payout_list","view_single_fiat_payout_list"],permissionSource: "transactions"},
//   { key: "settlement", label: "Settlements",  icon: "settlements", permission: ["view_settlement_list","view_schedule_settlement_list"],permissionSource: "settlement"},
//   { key: "subscription", label: "Subscription",  icon: "subscriptions", permission: "view_subscription_list",permissionSource: "subscription"},
//   { key: "api-request-logs", label: "API Request Logs",  icon: "api_request_logs", permission: "view_api_request_logs",permissionSource: "api_request_logs" },
];

const TabIcon = ({ icon }: { icon: string }) => {
    const icons: Record<string, JSX.Element> = {
        gateway: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>,
        checkout: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>,
        routing: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 3h6l6 18h6"/><path d="M14.25 8.25H21"/></svg>,
        treasury: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
        users: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
        transactions: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="16" rx="2"/><path d="M7 8h10"/><path d="M7 12h6"/><path d="M7 16h8"/></svg>,
        settlements: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 3v18"/><path d="M17 7h-6.5a3.5 3.5 0 0 0 0 7H17"/><path d="M7 21h6.5a3.5 3.5 0 0 0 0-7H7"/><path d="M19 5l2 2-2 2"/></svg>,
        subscriptions: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 0 1-15.6 6.1"/><path d="M3 12a9 9 0 0 1 15.6-6.1"/><path d="M3 16v2h2"/><path d="M21 8V6h-2"/><path d="M12 7v5l3 2"/></svg>,
        api_request_logs: <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M8 13h8"/><path d="M8 17h5"/></svg>,
    };
    return icons[icon] ?? null;
};

const ClientDetails = () => {
    const { id } = useParams();
    const [clientData, setClientData] = useState<any>({});
    const [allGateways, setAllGateways] = useState<AllGatewayObj[]>([]);
    const [methodName, setMethodName] = useState<boolean>(false);
    const { singleRoleData } = useContext(ClientContext);
    const [checkedpaymentMethods, setCheckedPaymentMethods] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [activeTab, setActiveTab] = useState<string>("");
    const [gatewayRefreshKey, setGatewayRefreshKey] = useState(0);
    const permissions = singleRoleData?.[0]?.client?.value;
    const payment_permission = singleRoleData?.[0]?.payment?.value;
    const payout_permission = singleRoleData?.[0]?.payout?.value;
    const fiat_permission = singleRoleData?.[0]?.fiat?.value;
    const crypto_permission = singleRoleData?.[0]?.crypto?.value;
    const settlement_permission = singleRoleData?.[0]?.settlement?.value;
    const schedule_settlement_permission = singleRoleData?.[0]?.schedule_settlement?.value;
    const subscription_permission = singleRoleData?.[0]?.subscription?.value;
    const api_request_logs_permission = singleRoleData?.[0]?.api_request_logs?.value;

    const TRANSACTION_TABS = [
        {key: "transaction",label: "Transaction",permission:payment_permission?.view_payment_list},
        {key: "regular-payout",label: "Regular Payout",permission:payout_permission?.view_payout_list ||payout_permission?.view_batch_payout},
        {key: "fiat-payout",label: "Fiat Payout",permission:fiat_permission?.view_fiat_payout_list || fiat_permission?.view_single_fiat_payout_list},
        {key: "crypto-payout",label: "Crypto Payout",permission:crypto_permission?.view_crypto_payout_list || crypto_permission?.view_single_crypto_payout_list},
    ];

    const [activeTransactionTab, setActiveTransactionTab] = useState("");

    useEffect(() => {
        const firstAvailableTab = TRANSACTION_TABS.find((tab) => tab.permission);

        if (firstAvailableTab) {
            setActiveTransactionTab(firstAvailableTab.key);
        }
    }, [singleRoleData]);

    const hasTabPermission = (tab: {permission: string | string[]; permissionSource: string;}) => {
        let permissionData: Record<string, any> | undefined;
        switch (tab.permissionSource) {
            case "client":
                permissionData = permissions;
                break;

            case "transactions":
                permissionData = {
                    ...payment_permission,
                    ...payout_permission,
                    ...fiat_permission,
                    ...crypto_permission,
                };
                break;

            case "settlement":
                permissionData = {
                    ...settlement_permission,
                    ...schedule_settlement_permission,
                };
                break;

            case "subscription":
                permissionData = subscription_permission;
                break;

            case "api_request_logs":
                permissionData = api_request_logs_permission;
                break;

            default:
                return false;
        }

        if (!permissionData) return false;

        if (Array.isArray(tab.permission)) {
            return tab.permission.some(
            (permission) => !!permissionData?.[permission]
            );
        }

        return !!permissionData?.[tab.permission];
    };

    const visibleTabs = TAB_CONFIG.filter((tab) => hasTabPermission(tab)); 
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [orgID, setOrgID] = useState<any>(undefined);
    const refetchClient = () => {
        const method_name = singleRoleData[0]?.client?.value?.client_show_method_name;
        fetchAllGateways().then((gateways: any) => {
            fetchClient(gateways, method_name);
        });
    };
    useEffect(() => {
        if (!permissions) return;
        const first = TAB_CONFIG.find((tab) => hasTabPermission(tab));
        if (first && !activeTab) {setActiveTab(first.key);}
    }, [singleRoleData]);

    useEffect(() => {
        if (orgID !== undefined) {
          getOrganization({ id: orgID })
            .then((data: any) => setPaymentMethods(data[0]?.payment_methods))
            .catch((err: any) => toast.error(err?.response?.data?.message ?? "Unable to fetch data"));
        }
    }, [orgID]);

    async function fetchClient(gateways:any,method_name:any,onDone?:()=>void){
        getClient(id)
        .then(async(data:any)=>{
            setClientData(data[0]??{});
            setOrgID(data[0].org_id??undefined);

            const selected=data[0]?.assigned_payment_methods?.map((ele:any)=>{
                const gateway=gateways?.find((item:any)=>item.id===ele);
                return{value:ele,label:method_name?gateway?.name:ele};
            });

            setCheckedPaymentMethods(selected??[]);

            const res=await getProfileSecond();

            const userFullName=`${res?.[0]?.first_name??""} ${res?.[0]?.last_name??""}`.trim();

            const logData={
                user_id:getUserId(),
                message:`${userFullName} has been visited the ${data[0].name} client details page`,
                module : "Client"
            };

            storeAuditLogsGeneral(logData).then(()=>{}).catch(()=>{});

            onDone?.();
        })
        .catch((err:any)=>toast.error(err?.response?.data?.message??"Unable to fetch data"))
        .finally(()=>setIsLoading(false));
    }

    const fetchAllGateways = async () => {
        const gateways = await getAllGatewaysSecond();
        setAllGateways(gateways?.[0] ? gateways : []);
        return gateways?.[0] ? gateways : [];
    };

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if (!id) return;
        const method_name = singleRoleData[0]?.client?.value?.client_show_method_name;
        setMethodName(method_name);
        const load = async () => {
            try { const gateways = await fetchAllGateways(); fetchClient(gateways, method_name); }
            catch (err) { console.error(err); }
        };
        load();
    }, [id]);

    const formatDate = (str: string) => {
        if (!str) return "—";
        try { return new Date(str).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit" }); }
        catch { return str; }
    };

    const enabledGateways = Object.entries(clientData?.client_gateway_active ?? {}).filter(([, v]) => v).map(([k]) => k);

    const [copied, setCopied] = useState<string>("");
    const copy = (text: string, key: string) => { navigator.clipboard.writeText(text); setCopied(key); setTimeout(() => setCopied(""), 1500); };

    const CopyBtn = ({ value, id: key }: { value: string; id: string }) => (
        <button className={`cd-copy-btn${copied === key ? " cd-copy-btn--done" : ""}`} onClick={() => copy(value, key)}>
        {copied === key ? (
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        ) : (
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
        )}
        {copied === key ? "Copied" : "Copy"}
        </button>
    );

    const hasAddress = clientData.address || clientData.city || clientData.state || clientData.country;

    const fakeInfoData = { row: { original: clientData } };

    if (isLoading) {
        return (
        <div className="cd-root">
            <div className="cd-loading"><div className="cd-spinner" /><p className="cd-loading-txt">Loading client details…</p></div>
            <CdStyles />
        </div>
        );
    }

    return (
        <div className="cd-root">

            <div className="cd-page-header">
                <div className="cd-page-title-block">
                    <Link to="/admin/clients" className="cd-back-link">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
                        Clients
                    </Link>
                    <div className="cd-breadcrumb-sep">/</div>
                    <div className="cd-page-icon">
                        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                    </div>
                    <div>
                        <h1 className="cd-page-heading">{clientData.name || "Client Details"}</h1>
                        <p className="cd-page-sub">{clientData.org_name || "—"}</p>
                    </div>
                </div>
                <div className="cd-header-right">
                    <div className="cd-status-badge cd-status-badge--active"><div className="cd-status-dot" />Active</div>
                    {clientData.isSmartRouteEnabled && (
                        <div className="cd-status-badge cd-status-badge--smart">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>
                        Smart Route
                        </div>
                    )}
                </div>
            </div>

            {permissions?.view_client && (
                <div className="cd-hero-card">
                    <div className="cd-hero-avatar">{clientData.name?.charAt(0)?.toUpperCase() || "C"}</div>
                    <div className="cd-hero-info">
                        <h2 className="cd-hero-name">{clientData.name || "—"}</h2>
                        <p className="cd-hero-org">
                        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
                        {clientData.org_name || "—"}
                        </p>
                        {clientData.description && <p className="cd-hero-desc">{clientData.description}</p>}
                    </div>
                    <div className="cd-hero-meta">
                        <div className="cd-hero-meta-item">
                        <span className="cd-hero-meta-label">Created</span>
                        <span className="cd-hero-meta-value">{formatDate(clientData.created_at)}</span>
                        </div>
                    </div>
                </div>
            )}

            {permissions?.view_client && (
                <div className="cd-grid">
                    <div className="cd-card cd-card--span2">
                        <div className="cd-card-header">
                        <div className="cd-card-icon cd-card-icon--blue"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></div>
                        <h3 className="cd-card-title">API Credentials</h3>
                        <span className="cd-card-badge cd-card-badge--amber">Sensitive</span>
                        </div>
                        <div className="cd-card-body">
                        <div className="cd-cred-row">
                            <div className="cd-cred-item">
                            <label className="cd-cred-label">Client ID</label>
                            <div className="cd-cred-value-wrap">
                                <code className="cd-cred-code">{clientData.client_id || "—"}</code>
                                {clientData.client_id && <CopyBtn value={clientData.client_id} id="client_id" />}
                            </div>
                            </div>
                            <div className="cd-cred-item">
                            <label className="cd-cred-label">Client Secret</label>
                            <div className="cd-cred-value-wrap">
                                <code className="cd-cred-code cd-cred-code--masked">{clientData.client_secret ? clientData.client_secret.slice(0, 8) + "••••••••••••••••" + clientData.client_secret.slice(-4) : "—"}</code>
                                {clientData.client_secret && <CopyBtn value={clientData.client_secret} id="client_secret" />}
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="cd-card-row cd-card--span2">
                        {/* Contact */}
                        <div className="cd-card">
                        <div className="cd-card-header">
                            <div className="cd-card-icon cd-card-icon--green"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg></div>
                            <h3 className="cd-card-title">Contact</h3>
                        </div>
                        <div className="cd-card-body">
                            <div className="cd-info-list">
                            <div className="cd-info-item"><span className="cd-info-label">Email</span><span className="cd-info-value">{clientData.email || <span className="cd-info-empty">Not provided</span>}</span></div>
                            <div className="cd-info-item"><span className="cd-info-label">Phone</span><span className="cd-info-value">{clientData.phone || <span className="cd-info-empty">Not provided</span>}</span></div>
                            <div className="cd-info-item"><span className="cd-info-label">Website</span>{clientData.website ? <a href={clientData.website} target="_blank" rel="noopener noreferrer" className="cd-info-link">{clientData.website}<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg></a> : <span className="cd-info-empty">Not provided</span>}</div>
                            </div>
                        </div>
                        </div>

                        {/* Address */}
                        <div className="cd-card">
                        <div className="cd-card-header">
                            <div className="cd-card-icon cd-card-icon--purple"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg></div>
                            <h3 className="cd-card-title">Address</h3>
                        </div>
                        <div className="cd-card-body">
                            {hasAddress ? (
                            <div className="cd-address-block">
                                {clientData.address && <p className="cd-address-line">{clientData.address}</p>}
                                <p className="cd-address-line">{[clientData.city, clientData.state, clientData.postal_code].filter(Boolean).join(", ")}</p>
                                {clientData.country && <p className="cd-address-line">{clientData.country}</p>}
                            </div>
                            ) : (
                            <div className="cd-empty-state"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg><span>No address provided</span></div>
                            )}
                        </div>
                        </div>

                        {/* Gateways */}
                        <div className="cd-card">
                        <div className="cd-card-header">
                            <div className="cd-card-icon cd-card-icon--blue"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg></div>
                            <h3 className="cd-card-title">Enabled Gateways</h3>
                            <span className="cd-card-badge">{enabledGateways.length}</span>
                        </div>
                        <div className="cd-card-body">
                            {enabledGateways.length > 0 ? (
                            <div className="cd-gateway-pills">
                                {enabledGateways.map((gw) => {
                                const gatewayObj = allGateways?.find((item) => item.name === gw);
                                const display = methodName ? gatewayObj?.name || gw : (gatewayObj as any)?.id || gw;
                                return (
                                    <div key={gw} className="cd-gateway-pill">
                                    <div className="cd-gateway-dot" />{display}
                                    </div>
                                );
                                })}
                            </div>
                            ) : (
                            <div className="cd-empty-state"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#cbd5e1" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg><span>No gateways enabled</span></div>
                            )}
                        </div>
                        </div>
                    </div>
                </div>
            )}

            {visibleTabs.length > 0 && (
                <div className="cd-tabs-placeholder">
                    <div className="cd-tabs-bar">
                        {visibleTabs.map((tab) => (
                        <button
                            key={tab.key}
                            className={`cd-tab${activeTab === tab.key ? " cd-tab--active" : ""}`}
                            onClick={() => setActiveTab(tab.key) }
                        >
                            <span className="cd-tab-icon"><TabIcon icon={tab.icon} /></span>
                            {tab.label}
                        </button>
                        ))}
                    </div>
                    <div className="cd-tabs-content">
                        {activeTab === "gateway-setting" && permissions?.client_gateway_settings && (
                          <CreateClientGatewaysModal
                            key={gatewayRefreshKey}
                            fetchClients={() => {}}
                            id={clientData.client_id}
                            infoData={fakeInfoData}
                            assigned_payment_methods={{ assigned_payment_methods: clientData.assigned_payment_methods }}
                            // refreshParent={() =>setGatewayRefreshKey(prev => prev + 1)}
                            refreshParent={() => {
                                const method_name = singleRoleData[0]?.client?.value?.client_show_method_name;
                                fetchAllGateways().then((gateways: any) => {
                                    fetchClient(gateways, method_name, () => {
                                        setGatewayRefreshKey(prev => prev + 1);
                                    });
                                });
                            }}
                            gatewayRefreshKey={gatewayRefreshKey}
                            paymentMethods={paymentMethods}
                            allGateways={allGateways}
                            org_id = {orgID}
                            isupdating={isLoading}
                          />
                        )}
                        {activeTab === "checkout-setting" && permissions?.client_checkout_setting && (
                        <CheckoutProductClientModal
                            fetchClients={() => {}}
                            id={clientData.client_id}
                            secret={clientData.client_secret}
                            infoData={fakeInfoData}
                            assigned_payment_methods={{ assigned_payment_methods: clientData.assigned_payment_methods }}
                        />
                        )}
                        {activeTab === "gateway-routing" && permissions?.client_gateway_routing && (
                        <ArrangeClientModal
                            id={clientData.client_id}
                            value={clientData}
                            fetchClients={() => {}}
                        />
                        )}
                        {activeTab === "treasury" && permissions?.view_client_treasury && (
                        <AddTreasury
                            id={clientData.client_id}
                            fetchClients={() => {}}
                            roleData={singleRoleData}
                        />
                        )}
                        {activeTab === "customer-registration" && permissions?.customer_registration && (
                        <CustomerRegistration client_id={clientData.client_id} />
                        )}
                        {activeTab === "all-transactions" && (payment_permission?.view_payment_list || payout_permission?.view_payout_list || payout_permission?.view_batch_payout || crypto_permission?.view_crypto_payout_list || crypto_permission?.view_single_crypto_payout_list || fiat_permission?.view_fiat_payout_list || fiat_permission?.view_single_fiat_payout_list) && (
                            <>
                                <div className="cd-tabs-placeholder">
                                    <div className="cd-tabs-bar">
                                        {TRANSACTION_TABS.map(
                                            (tab) =>
                                                tab.permission && (
                                                    <button
                                                        key={tab.key}
                                                        className={`cd-tab${activeTransactionTab === tab.key ? " cd-tab--active" : ""}`}
                                                        onClick={() => setActiveTransactionTab(tab.key)}
                                                    >
                                                        {tab.label}
                                                    </button>
                                                )
                                        )}
                                    </div>
                                    <div className="">
                                        {activeTransactionTab === "transaction" &&  payment_permission?.view_payment_list && (
                                            <AllPaymentsClient client_id={clientData.client_id}/>
                                        )}
                                        {activeTransactionTab === "regular-payout" && (payout_permission?.view_payout_list || payout_permission?.view_batch_payout) && (
                                            <AllPayoutsClient client_id={clientData.client_id}/>
                                        )}
                                        {activeTransactionTab === "fiat-payout" && (fiat_permission?.view_single_fiat_payout_list || fiat_permission?.view_single_fiat_payout_list) && (
                                            <></>
                                        )}
                                        {activeTransactionTab === "crypto-payout" && (crypto_permission?.view_crypto_payout_list || crypto_permission?.view_single_crypto_payout_list) && (
                                            <></>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}
                        {activeTab === "settlement" && (settlement_permission?.view_settlement_list || schedule_settlement_permission?.view_schedule_settlement_list) && (
                            <></>
                        )}
                        {activeTab === "subscription" && subscription_permission?.view_subscription_list && (
                            <></>
                        )}
                        {activeTab === "api-request-logs" && api_request_logs_permission?.view_api_request_logs && (
                            <></>
                        )}
                    </div>
                </div>
            )}

            <CdStyles />
        </div>
    );
};

const CdStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

    .cd-root { font-family: 'Plus Jakarta Sans', sans-serif; min-height: 100vh; display: flex; flex-direction: column; gap: 20px; }
    .cd-tabs-coming { display: flex; flex-direction: column; align-items: center; gap: 10px; }
    .cd-tabs-coming-title { font-size: 14px; font-weight: 700; color: #64748b; }
    .cd-loading { display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1; gap: 14px; padding: 80px; }
    .cd-spinner { width: 32px; height: 32px; border: 3px solid #e2e8f0; border-top-color: #2563eb; border-radius: 50%; animation: cdSpin .7s linear infinite; }
    @keyframes cdSpin { to { transform: rotate(360deg); } }
    .cd-loading-txt { font-size: 14px; color: #94a3b8; font-weight: 500; }

    .cd-page-header { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 14px; }
    .cd-page-title-block { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
    .cd-back-link { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: #2563eb; text-decoration: none; padding: 6px 12px; border-radius: 8px; background: #eff6ff; border: 1.5px solid #bfdbfe; transition: all .15s; }
    .cd-back-link:hover { background: #dbeafe; border-color: #93c5fd; }
    .cd-breadcrumb-sep { color: #cbd5e1; font-size: 16px; }
    .cd-page-icon { width: 40px; height: 40px; border-radius: 11px; background: linear-gradient(135deg,#eff6ff,#dbeafe); border: 1.5px solid #bfdbfe; display: flex; align-items: center; justify-content: center; color: #2563eb; flex-shrink: 0; }
    .cd-page-heading { font-size: 20px; font-weight: 800; color: #0f172a; letter-spacing: -.4px; margin-bottom: 2px; line-height: 1.2; }
    .cd-page-sub { font-size: 13px; color: #94a3b8; font-weight: 500; }
    .cd-header-right { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
    .cd-status-badge { display: inline-flex; align-items: center; gap: 6px; font-size: 12px; font-weight: 700; padding: 6px 12px; border-radius: 100px; }
    .cd-status-badge--active { background: #f0fdf4; color: #15803d; border: 1.5px solid #bbf7d0; }
    .cd-status-badge--smart  { background: #eff6ff; color: #1d4ed8; border: 1.5px solid #bfdbfe; }
    .cd-status-dot { width: 7px; height: 7px; border-radius: 50%; background: #16a34a; box-shadow: 0 0 6px rgba(22,163,74,.5); }

    .cd-hero-card { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 18px; padding: 28px 32px; display: flex; align-items: flex-start; gap: 20px; box-shadow: 0 2px 8px rgba(15,23,42,.06); flex-wrap: wrap; }
    .cd-hero-avatar { width: 64px; height: 64px; border-radius: 16px; flex-shrink: 0; background: linear-gradient(135deg,#1d4ed8,#2563eb); display: flex; align-items: center; justify-content: center; font-size: 26px; font-weight: 800; color: #fff; box-shadow: 0 4px 16px rgba(37,99,235,.3); }
    .cd-hero-info { flex: 1; min-width: 180px; }
    .cd-hero-name { font-size: 22px; font-weight: 800; color: #0f172a; letter-spacing: -.4px; margin-bottom: 5px; line-height: 22px; }
    .cd-hero-org { display: flex; align-items: center; gap: 6px; font-size: 13.5px; color: #64748b; font-weight: 600; margin-bottom: 8px; }
    .cd-hero-desc { font-size: 13px; color: #94a3b8; font-weight: 500; line-height: 1.55; }
    .cd-hero-meta { display: flex; gap: 24px; flex-wrap: wrap; align-items: center; }
    .cd-hero-meta-item { display: flex; flex-direction: column; align-items: flex-end; gap: 2px; }
    .cd-hero-meta-label { font-size: 11px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: .5px; }
    .cd-hero-meta-value { font-size: 15px; font-weight: 700; color: #0f172a; }

    .cd-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 16px; }
    .cd-card--span2 { grid-column: 1/-1; }
    .cd-card-row { display: grid; grid-template-columns: repeat(3,1fr); gap: 16px; }
    @media (max-width: 992px) { .cd-card-row { grid-template-columns: repeat(2,1fr); } }
    @media (max-width: 576px) { .cd-card-row { grid-template-columns: 1fr; } }

    .cd-card { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 16px; overflow: hidden; box-shadow: 0 1px 4px rgba(15,23,42,.05); transition: box-shadow .18s; }
    .cd-card:hover { box-shadow: 0 4px 16px rgba(15,23,42,.08); }
    .cd-card-header { padding: 16px 20px; border-bottom: 1px solid #f1f5f9; display: flex; align-items: center; gap: 10px; background: #fafbfc; }
    .cd-card-icon { width: 34px; height: 34px; border-radius: 9px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; }
    .cd-card-icon--blue   { background: linear-gradient(135deg,#eff6ff,#dbeafe); border: 1.5px solid #bfdbfe; color: #2563eb; }
    .cd-card-icon--green  { background: linear-gradient(135deg,#f0fdf4,#dcfce7); border: 1.5px solid #bbf7d0; color: #16a34a; }
    .cd-card-icon--purple { background: linear-gradient(135deg,#faf5ff,#ede9fe); border: 1.5px solid #ddd6fe; color: #7c3aed; }
    .cd-card-title { font-size: 14px; font-weight: 700; color: #0f172a; flex: 1; }
    .cd-card-badge { font-size: 11.5px; font-weight: 700; padding: 3px 10px; border-radius: 100px; background: #eff6ff; color: #1d4ed8; border: 1px solid #bfdbfe; }
    .cd-card-badge--amber { background: #fffbeb; color: #d97706; border-color: #fde68a; }
    .cd-card-body { padding: 18px 20px; }

    /* ── API Credentials — THE FIX ──
       Key insight: flex: 1 1 0% on the code means it grows into available space
       but also SHRINKS below its content width. flex-shrink:0 on copy btn
       ensures the button is always fully visible. overflow:hidden on the wrapper
       clips anything that still escapes. min-width:0 on both container and code
       unlocks the CSS shrink behaviour (default min-width:auto blocks it).
    */
    .cd-cred-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
    .cd-cred-item { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
    .cd-cred-label { font-size: 11.5px; font-weight: 700; color: #64748b; text-transform: uppercase; letter-spacing: .4px; }
    .cd-cred-value-wrap {
      display: flex; align-items: center; gap: 8px;
      background: #f8fafc; border: 1.5px solid #e2e8f0; border-radius: 10px; padding: 10px 14px;
      min-width: 0;       /* allow children to shrink */
      overflow: hidden;   /* clip any residual overflow */
    }
    .cd-cred-code {
      font-family: 'Courier New', monospace; font-size: 12.5px; font-weight: 600; color: #1e293b;
      flex: 1 1 0%;       /* grow AND shrink, starting from 0 base */
      overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
      min-width: 0; letter-spacing: .3px;
    }
    .cd-cred-code--masked { color: #64748b; letter-spacing: 1px; }
    .cd-copy-btn {
      display: inline-flex; align-items: center; gap: 4px;
      font-family: 'Plus Jakarta Sans', sans-serif; font-size: 11.5px; font-weight: 600;
      padding: 4px 9px; border-radius: 6px; border: 1.5px solid #e2e8f0;
      background: #fff; color: #64748b; cursor: pointer; transition: all .15s;
      flex-shrink: 0;     /* never compress — always fully visible */
      white-space: nowrap;
    }
    .cd-copy-btn:hover { border-color: #93c5fd; color: #2563eb; background: #eff6ff; }
    .cd-copy-btn--done { border-color: #bbf7d0; color: #15803d; background: #f0fdf4; }

    .cd-info-list { display: flex; flex-direction: column; gap: 12px; }
    .cd-info-item { display: flex; align-items: center; justify-content: space-between; gap: 8px; flex-wrap: wrap; }
    .cd-info-label { font-size: 12.5px; font-weight: 600; color: #64748b; flex-shrink: 0; }
    .cd-info-value { font-size: 13px; font-weight: 600; color: #0f172a; text-align: right; word-break: break-all; }
    .cd-info-empty { font-size: 12.5px; color: #cbd5e1; font-style: italic; font-weight: 500; }
    .cd-info-link { display: inline-flex; align-items: center; gap: 4px; font-size: 13px; font-weight: 600; color: #2563eb; text-decoration: none; word-break: break-all; }
    .cd-info-link:hover { color: #1d4ed8; text-decoration: underline; }

    .cd-address-block { display: flex; flex-direction: column; gap: 4px; }
    .cd-address-line { font-size: 13.5px; color: #374151; font-weight: 500; line-height: 1.6; }

    .cd-gateway-pills { display: flex; flex-wrap: wrap; gap: 8px; }
    .cd-gateway-pill { display: inline-flex; align-items: center; gap: 7px; background: #f0fdf4; border: 1.5px solid #bbf7d0; border-radius: 9px; padding: 7px 12px; font-size: 13px; font-weight: 600; color: #15803d; }
    .cd-gateway-dot { width: 7px; height: 7px; border-radius: 50%; background: #16a34a; box-shadow: 0 0 5px rgba(22,163,74,.4); }

    .cd-empty-state { display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 8px; padding: 24px 0; }
    .cd-empty-state span { font-size: 13px; color: #94a3b8; font-weight: 500; }

    .cd-tabs-placeholder { background: #ffffff; border: 1px solid #e2e8f0; border-radius: 18px; overflow: hidden; box-shadow: 0 1px 4px rgba(15,23,42,.05); }
    .cd-tabs-bar { display: flex; border-bottom: 1.5px solid #e2e8f0; background: #fafbfc; padding: 0 4px; gap: 0; overflow-x: auto;overflow-y: hidden; -webkit-overflow-scrolling: touch; }
    .cd-tabs-bar::-webkit-scrollbar { height: 3px; }
    .cd-tabs-bar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 100px; }
    .cd-tab { display: inline-flex; align-items: center; gap: 7px; padding: 14px 18px; font-family: 'Plus Jakarta Sans', sans-serif; font-size: 13px; font-weight: 600; color: #64748b; background: none; border: none; border-bottom: 2.5px solid transparent; cursor: pointer; white-space: nowrap; transition: color .15s, border-color .15s; margin-bottom: -1.5px; }
    .cd-tab:hover { color: #2563eb; }
    .cd-tab--active { color: #2563eb; border-bottom-color: #2563eb; }
    .cd-tab-icon { display: flex; align-items: center; opacity: .7; }
    .cd-tab--active .cd-tab-icon { opacity: 1; }
    .cd-tabs-content { padding: 28px 28px 32px; }

    /* ══ RESPONSIVE ══ */

    @media (max-width: 900px) {
      .cd-grid { grid-template-columns: 1fr; }
      .cd-card--span2 { grid-column: auto; }
      .cd-hero-card { flex-direction: column; }
      .cd-hero-meta { gap: 14px; }
      .cd-hero-meta-item { align-items: flex-start; }
    }

    @media (max-width: 600px) {
      /* Credentials: stack vertically */
      .cd-cred-row { grid-template-columns: 1fr; gap: 12px; }
      .cd-cred-value-wrap { padding: 9px 10px; gap: 6px; border-radius: 9px; }
      .cd-cred-code { font-size: 11px; }
      .cd-copy-btn { font-size: 10.5px; padding: 4px 8px; gap: 3px; }

      /* Contact: label stacks above value */
      .cd-info-item { flex-direction: column; align-items: flex-start; gap: 3px; }
      .cd-info-value { text-align: left; }

      .cd-hero-card { padding: 20px; }
      .cd-hero-name { font-size: 19px; }
      .cd-page-heading { font-size: 17px; }
      .cd-tabs-content { padding: 20px 16px; }
      .cd-card-body { padding: 14px 16px; }
      .cd-card-header { padding: 13px 16px; }
    }

    /* Very small (≤380px) — icon-only copy button */
    @media (max-width: 380px) {
      .cd-cred-value-wrap { padding: 8px 10px; gap: 4px; }
      .cd-cred-code { font-size: 10.5px; }
      /* Hide button text, show icon only */
      .cd-copy-btn { font-size: 0; padding: 5px 7px; gap: 0; }
      .cd-copy-btn svg { width: 13px; height: 13px; }
      .cd-otp-box { width: 38px; height: 46px; font-size: 17px; border-radius: 10px; }
      .cd-tabs-content { padding: 16px 12px 20px; }
    }
  `}</style>
);

export default ClientDetails;